export default "__VITE_ASSET__BI41F5Xb__"